export class AnnualRequirement {
    UserId: string;
    file:File;
}

    

